<template>
<div v-if="img" class="circular--portrait" :style="wrapperStyle"><img alt="Referent" :src="img"></div>
</template>

<script>
export default {
  name: 'RTAvatar',
  components:{
  },
  props:{
    img:{
      type:String
    },
    size:{
      type:String,
      default:"100px"
    }
  },
  watch:{
  },
  data: function() {
    return {
    };
  },
  computed:{
    wrapperStyle(){
      return {
        width:this.size,
        height:this.size,
      }
    }

  },
  methods:{
   
  },

  mounted(){
  },
};
</script>

<style scoped type='text/css'>
.circular--portrait {
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  border: solid 1px #CCCCCC;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}
</style>